import { render } from "./AskDetailComponent.vue?vue&type=template&id=8c6e6774"
import script from "./AskDetailComponent.vue?vue&type=script&lang=js"
export * from "./AskDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__